import { ActivatedRoute, Router } from "@angular/router";
import { TableColumnModel } from "../templates/table-template/tableModel";

export abstract class BaseTableComponent {
  tableData: any[] = [];
  columnList: TableColumnModel[] = [];
  first = 0;
  page = 1;
  defaultRowsPerPage = 10;
  rowsPerPage = 10;
  rowsPerPageOptions = [5, 10, 20, 50];
  multiSortMeta!: { field: string, order: number, hidden?: boolean }[];
  
  constructor(protected router: Router, protected route: ActivatedRoute) { }

  protected manageRouteParameters() {
    //set table page based on entry Id (navigation from edit/view/new submission) or page number from URL query param
    const entryId = this.route.snapshot.queryParamMap.get('entryId') ?? null;
    if (entryId) {
      const index = this.tableData.findIndex(entry => entry.entry_id === entryId);
      this.first = Math.floor(index / 10) * 10;
      this.page = (this.first / this.rowsPerPage) + 1;
    }
    else {
      this.page = Number(this.route.snapshot.queryParamMap.get('page') ?? this.page);
    }
    this.rowsPerPage = Number(this.route.snapshot.queryParamMap.get('rows-per-page') ?? this.rowsPerPage);
    if (!this.rowsPerPageOptions.includes(this.rowsPerPage)) {
      this.rowsPerPage = this.defaultRowsPerPage;
    }
    if (this.page < 1) {
      this.page = 1;
    }
    if (this.page > Math.ceil(this.tableData.length / this.rowsPerPage)) {
      this.page = Math.ceil(this.tableData.length / this.rowsPerPage);
    }
    //Replace current history if entryId was used to set page number in table-based component routes
    this.rewriteRouteQueryParams(this.page, this.rowsPerPage, entryId != null);
  }

  protected rewriteRouteQueryParams(selectedPage: number, rowsPerPage: number, replaceUrl = false) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { 'page': selectedPage, 'rows-per-page': rowsPerPage },
      replaceUrl: replaceUrl
    });
  }
}